<template>
  <div>
    <b-modal :id="id" lazy static centered size="lg" @show="showModalEdicioUsuari" @ok="handleSubmitEdicioUsuari" @hidden="hideModalEdicioUsuari" :title='$t("admin.usuaris.edicio.titol")'>
      <b-form ref="formEdicioUsuari" @submit.stop.prevent="handleSubmit">
        <b-form-group id="input-group-1" :label='$t("admin.usuaris.edicio.nom")+":"' label-size="sm" label-for="input-1" label-cols="4" label-cols-lg="2">
          <b-form-input id="input-1" v-model="formUsuari.nomUsuari" type="text" required size="sm" :placeholder='$t("admin.usuaris.edicio.usuplaceholder")'></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" :label='$t("admin.usuaris.edicio.pass")+":"' label-size="sm" label-for="input-1" label-cols="4" label-cols-lg="2">
          <b-form-input id="input-2" v-if="requiredPass" v-model="formUsuari.pass" type="text" size="sm" :placeholder='$t("admin.usuaris.edicio.pass")' ></b-form-input>
          <b-form-input id="input-2" v-if="!requiredPass" v-model="formUsuari.pass" type="text" :required="requiredPass" size="sm" :placeholder='$t("admin.usuaris.edicio.passplaceholder")' ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-3" :label='$t("admin.usuaris.edicio.entitat")+":"' label-size="sm" label-for="input-1" label-cols="4" label-cols-lg="2">
          <b-form-input readonly id="input-3" v-model="entitatUsuariActual.nom" type="text" required size="sm"></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-4" :label='$t("admin.usuaris.edicio.rols")+":"' label-size="sm" label-for="input-2" label-cols="4" label-cols-lg="2">
          <b-form-tags id="tags-component-select" v-model="rolsSeleccionats" size="lg" class="mb-2" add-on-change no-outer-focus>
            <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
              <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                <li v-for="tag in tags" :key="tag" class="list-inline-item">
                  <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="info">{{ tag }}</b-form-tag>
                </li>
              </ul>
              <b-form-select v-bind="inputAttrs" v-on="inputHandlers" :disabled="disabled || availableOptions.length === 0" :options="availableOptions">
                <template #first>
                  <!-- This is required to prevent bugs with Safari -->
                  <option disabled value="">Seleccioneu un o més rols...</option>
                </template>
              </b-form-select>
            </template>
          </b-form-tags>
        </b-form-group>

<!--        Missatge momentani -->
        <b-alert v-model="mostrarAlertaValidacions" variant="danger" dismissible>
          El nom d'usuari ja existeix.
        </b-alert>

      </b-form>
    </b-modal>
  </div>
</template>

<script>
import usuariAplicacioService from "@/services/UsuariAplicacioService";
export default {
  name: "ModalEdicioUsuari",
  props: {
    id: {
      type: String,
      required: true
    },
    usuari:{
      type: Object,
      required: true
    }
  },
  data() {
    return {
      rolsSeleccionats: [],
      filtre:{},
      formUsuari:{},
      entitatUsuariActual: {},
      mostrarAlertaValidacions: false,
      usuaris: []
    };
  },
  computed: {
    availableOptions() {
      return this.formUsuari.rols != null ? this.formUsuari.rols.filter(opt => this.rolsSeleccionats.indexOf(opt) === -1) : [];
    },
    requiredPass(){
      return !this.usuari.idUsuari ? true : false;
    }
  },
  methods: {
    showModalEdicioUsuari() {
      //Actualizamos el listado de usuarios para hacer las validaciones
      this.updateUsuaris();
      this.reiniciarVariablesModal();

      if(this.usuari.idUsuari){
        console.log("showModalEdicioUsuari");
        this.formUsuari.idUsuari = this.usuari.idUsuari;
        this.formUsuari.nomUsuari = this.usuari.nomUsuari;
        this.rolsSeleccionats = this.usuari.rols;
        this.formUsuari.organitzacio = this.usuari.organitzacio;
        this.formUsuari.dataCreacio = this.usuari.dataCreacio;
        this.formUsuari.dataBaixa = this.usuari.dataBaixa;
        this.formUsuari.entitat = this.entitatUsuariActual;
      }
      console.log(this.formUsuari.rols);
    },
    handleSubmitEdicioUsuari(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();

      this.mostrarAlertaValidacions = false;
      console.log("this.usuari.nomUsuari: "+this.usuari.nomUsuari);
      console.log("this.formUsuari.nomUsuari: "+this.formUsuari.nomUsuari);
      this.usuaris.forEach((element) => {
        console.log(element)
        if (this.usuari.nomUsuari != this.formUsuari.nomUsuari && element.nomUsuari === this.formUsuari.nomUsuari) {
          this.mostrarAlertaValidacions = true;
        }
      });

      //Validacion nombre usuario duplicado
      if(this.mostrarAlertaValidacions){
        return
      }

      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        console.log(this.mostrarAlertaValidacions);
        return
      }
      //Rellenamos los roles con los tags que esten seleccionados
      this.formUsuari.rols = this.rolsSeleccionats;
      this.formUsuari.entitat = this.entitatUsuariActual;

      usuariAplicacioService.saveUsuari(this.formUsuari).then(response => {

        this.$emit('usuari-editat', response.data)
        this.hideModalEdicioUsuari();

      })
          .catch(e => {
            console.error(e.response.data);
            console.error(e.response.data.error);
            console.error(e.message);
            console.log(e);
          });

    },
    hideModalEdicioUsuari(bvModalEvt) {
      //Actualizamos el listado de usuarios para hacer las validaciones
      this.updateUsuaris();

      this.reiniciarVariablesModal();

      // Prevent modal from closing
      if(bvModalEvt){bvModalEvt.preventDefault();}

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide(this.id)
      })

    },
    checkFormValidity() {
      const valid = this.$refs.formEdicioUsuari.checkValidity();
      return valid
    },
    reiniciarVariablesModal(){
      // Reset our form values
      this.formUsuari = this.emptyForm();
      // this.formUsuari.entitat = this.entitatUsuariActual;
      // Se rellena la lista de roles y se vacia el array con los tags seleccionados
      this.afegirRolsFormUsuari();
      this.rolsSeleccionats= [];
      this.mostrarAlertaValidacions = false;
    },
    emptyForm(){
      return {
        idUsuari:null,
        nomUsuari:null,
        pass:null,
        rols:[],
        organitzacio:null,
        dataCreacio:null,
        dataBaixa:null,
        entitat: null
      }
    },
    async entitatActual(){
      const response = await usuariAplicacioService.entitatUsuari();
      this.entitatUsuariActual = response.data;

      return response.data;
    },
    afegirRolsFormUsuari() {
      usuariAplicacioService.listRols()
          .then(response => {
            this.formUsuari.rols = [];
            var i;
            for (i = 0; i < response.data.length; i++) {
              this.formUsuari.rols.push(response.data[i])
            }
          })
          .catch(e => {
            console.log(e);
          });
    },
    updateUsuaris(){
      usuariAplicacioService.listUsuaris(this.filtre)
          .then(response => {
            this.usuaris = [];
            var i;
            for (i = 0; i < response.data.length; i++) {
              this.usuaris.push(response.data[i])
            }
          })
          .catch(e => {
            console.log(e);
          });
    }
  },
  mounted() {
    this.updateUsuaris();
    this.reiniciarVariablesModal();
  },
  created() {
    this.entitatActual();
  }

};
</script>

<style>
</style>